/**
 *
 * TCFCalendar
 *
 */

import React, { memo, useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment, { localeFr } from 'utils/moment/momentLocale';

// styles
import './style.scss';

// antd component
import { Calendar } from 'antd';

// icons
import { LeftOutlined, RightOutlined } from '@ant-design/icons';


function TCFCalendar({
  // states
  valueState,
  fullscreen,
  mode,
  // actions
  onPanelChange,
  onSelect,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-calendar-wrapper', className);

  const calendarHeaderRender = ({ value, type, onChange, onTypeChange }) => {
    /*  const current = value.clone();
    const localeData = value.localeData();
    const months = [];
    for (let i = 0; i < 12; i++) {
      current.month(i);
      months.push(localeData.monthsShort(current));
    } */

    const month = value.month();

    return (
      <div className="tcf-calendar__header">
        <h4 className="tcf-calendar__title">
          {value.format('dddd DD MMMM YYYY')}
        </h4>

        <div
          className="tcf-calendar__arrow tcf-calendar__btn-prev"
          onClick={() => {
            const selectedMonth = month - 1;
            const newValue = value.clone();
            newValue.month(parseInt(selectedMonth, 10));
            onChange(newValue);
          }}
        >
          <LeftOutlined />
        </div>

        <div
          className="tcf-calendar__arrow tcf-calendar__btn-next"
          onClick={() => {
            const selectedMonth = month + 1;
            const newValue = value.clone();
            newValue.month(parseInt(selectedMonth, 10));
            onChange(newValue);
          }}
        >
          <RightOutlined />
        </div>
      </div>
    );
  };

  const calendarHeaderDayRender = ({ value, type, onChange, onTypeChange }) => {
    /*  const current = value.clone();
    const localeData = value.localeData();
    const months = [];
    for (let i = 0; i < 12; i++) {
      current.month(i);
      months.push(localeData.monthsShort(current));
    } */

    const day = value.day();

    return (
      <div className="tcf-calendar__header">
        <h4 className="tcf-calendar__title">
          {value.format('dddd DD MMMM YYYY')}
        </h4>

        <div
          className="tcf-calendar__arrow tcf-calendar__btn-prev"
          onClick={() => {
            const selectedDay = day - 1;
            const newValue = value.clone();
            newValue.day(parseInt(selectedDay, 10));
            onChange(newValue);
          }}
        >
          <LeftOutlined />
        </div>

        <div
          className="tcf-calendar__arrow tcf-calendar__btn-next"
          onClick={() => {
            const selectedDay = day + 1;
            const newValue = value.clone();
            newValue.day(parseInt(selectedDay, 10));
            onChange(newValue);
          }}
        >
          <RightOutlined />
        </div>
      </div>
    );
  };

  return (
    <div className={childClassNames}>
      <Calendar
        className={`tcf-calendar ${mode}`}
        value={valueState}
        fullscreen={false}
        headerRender={
          mode == 'month' ? calendarHeaderRender : calendarHeaderDayRender
        }
        onPanelChange={onPanelChange}
        onSelect={onSelect}
        locale={localeFr}
        mode="month"
      />
    </div>
  );
}

TCFCalendar.defaultProps = {
  mode: 'month',
  fullscreen: false,
};
TCFCalendar.propTypes = {
  mode: PropTypes.oneOf(['month', 'day']),
};

export default memo(TCFCalendar);
